import React__default from 'react';
import './Preloader.scss.js';
import { classnames } from '../../../utils/classnames.js';

var Preloader = function Preloader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('preloader', "preloader--".concat(size), "preloader--".concat(variant), className),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "preloader__circle",
    viewBox: "0 0 50 50",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "preloader__path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5",
    "data-v-6e52f9c7": ""
  })));
};

export { Preloader as default };
